// InstallButton.js
import React, { useState, useEffect } from "react";
import "./App.css";

// Keep a single copy of the prompt event for the whole page session
// (survives SPA route changes)
function getSavedPrompt() {
  return window.__tvDeferredPrompt || null;
}
function savePrompt(e) {
  window.__tvDeferredPrompt = e;
}

export default function InstallButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(getSavedPrompt());
  const [show, setShow] = useState(!!getSavedPrompt());

  useEffect(() => {
    // If another InstallButton instance already captured the prompt earlier,
    // show immediately on mount.
    const existing = getSavedPrompt();
    if (existing) {
      setDeferredPrompt(existing);
      setShow(true);
    }

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      savePrompt(e);
      setDeferredPrompt(e);
      setShow(true);
    };

    const handleAppInstalled = () => {
      // Hide after successful install
      setShow(false);
      // Optional: remember not to nag again
      localStorage.setItem("pwaInstallDismissed", "1");
      // Clear the saved prompt (no longer valid after install)
      savePrompt(null);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt, { once: true });
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const handleClick = async () => {
    const promptEvent = deferredPrompt || getSavedPrompt();
    if (promptEvent) {
      promptEvent.prompt();
      const result = await promptEvent.userChoice;
      if (result.outcome === "accepted") {
        // User accepted; browser will fire 'appinstalled' if installation completes
        // Hide here as well for immediate feedback
        setShow(false);
        savePrompt(null);
      } else {
        // User dismissed; keep the saved prompt so they can try again later
        // (do NOT set localStorage dismissal here unless you want it gone forever)
      }
    }
  };

  // If you previously set a permanent dismissal somewhere, this will hide it
  if (localStorage.getItem("pwaInstallDismissed") === "1") return null;

  // Only render if we have the event (or have shown it already this session)
  if (!show) return null;

  return (
    <button className="install-button" onClick={handleClick}>
      Install Talkvee App
    </button>
  );
}
